import * as React from "react";
import { mergeStyles, registerIcons } from "@fluentui/react";
import { useId } from "@fluentui/react-hooks";
import { FontIcon, Icon } from "@fluentui/react/lib/Icon";
import { ITooltipHostStyles, TooltipHost } from "@fluentui/react/lib/Tooltip";
import * as Messages from "../../codegen/Messages";
import { Required } from "../Svg/icons";

const calloutProps = { gapSpace: 0 };
// The TooltipHost root uses display: inline by default.
// If that's causing sizing issues or tooltip positioning issues, try overriding to inline-block.
const hostStyles: Partial<ITooltipHostStyles> = { root: { display: "inline" } };

registerIcons({ icons: { "required-svg": Required } });

const iconClass = mergeStyles({
  fontSize: 13,
  verticalAlign: "middle",
  width: "10px",
  height: "14px",
  marginLeft: "5px",
});

const required = mergeStyles({
  fontSize: 15,
  verticalAlign: "super",
  marginLeft: "3px",
  marginRight: "3px",
  lineHeight: 0,
});

export interface Props {
  /**
   * Text to display as Tooltip
   */
  tooltip?: string;
  /**
   * Styles for the tooltip
   */
  styles?: string;
}

/**
 *The LabelInfoTooltip component renders the tooltip on hovering over the label info icon
 */

export const LabelInfoTooltip = ({ tooltip, styles }: Props): JSX.Element => {
  const tooltipId = useId("tooltip");
  return (
    <TooltipHost
      content={tooltip}
      // This id is used on the tooltip itself, not the host
      // (so an element with this id only exists when the tooltip is shown)
      id={tooltipId}
      calloutProps={calloutProps}
      styles={hostStyles}
    >
      <FontIcon
        aria-describedby={tooltipId}
        aria-label="Info"
        iconName="Info"
        className={styles !== undefined && styles !== null ? styles : iconClass}
      />
    </TooltipHost>
  );
};

/**
 * The RequiredTooltip component renders the tooltip on hovering over the required
 * icon
 */
export const RequiredTooltip = ({ styles }: Props): JSX.Element => {
  const tooltipId = useId("tooltip");
  return (
    <TooltipHost
      content={Messages.hints.requiredField()}
      // This id is used on the tooltip itself, not the host
      // (so an element with this id only exists when the tooltip is shown)
      id={tooltipId}
      calloutProps={calloutProps}
      styles={hostStyles}
    >
      <span
        aria-describedby={tooltipId}
        aria-label="Required"
        className={styles !== undefined && styles !== null ? styles : required}
      >
        <Icon iconName="required-svg" />
      </span>
    </TooltipHost>
  );
};
